import { render } from "./SeoRowV2.vue?vue&type=template&id=167acab4&scoped=true"
import script from "./SeoRowV2.vue?vue&type=script&lang=js"
export * from "./SeoRowV2.vue?vue&type=script&lang=js"

import "./SeoRowV2.vue?vue&type=style&index=0&id=167acab4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167acab4"]])

export default __exports__